import _classCallCheck from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectSpread from "/home/yasasvee/codeBase/polarimetry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { Component, createElement } from 'react';
import storeShape from '../utils/storeShape';
import shallowEqual from '../utils/shallowEqual';
import wrapActionCreators from '../utils/wrapActionCreators';
import warning from '../utils/warning';
import isPlainObject from 'lodash/isPlainObject';
import hoistStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars


var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _objectSpread({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = {
  value: null
};

function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
} // Helps track hot reloading.


var nextVersion = 0;
export default function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;
  var mapDispatch;

  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = wrapActionCreators(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === void 0 ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === void 0 ? false : _options$withRef;
  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps; // Helps track hot reloading.

  var version = nextVersion++;
  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = "Connect(".concat(getDisplayName(WrappedComponent), ")");

    function checkStateShape(props, methodName) {
      if (!isPlainObject(props)) {
        warning("".concat(methodName, "() in ").concat(connectDisplayName, " must return a plain object. ") + "Instead received ".concat(props, "."));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);

      if (process.env.NODE_ENV !== 'production') {
        checkStateShape(mergedProps, 'mergeProps');
      }

      return mergedProps;
    }

    var Connect = /*#__PURE__*/function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
          return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
        }
      }]);

      function Connect(props, context) {
        var _this;

        _classCallCheck(this, Connect);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Connect).call(this, props, context));
        _this.version = version;
        _this.store = props.store || context.store;
        invariant(_this.store, "Could not find \"store\" in either the context or " + "props of \"".concat(connectDisplayName, "\". ") + "Either wrap the root component in a <Provider>, " + "or explicitly pass \"store\" as a prop to \"".concat(connectDisplayName, "\"."));

        var storeState = _this.store.getState();

        _this.state = {
          storeState: storeState
        };

        _this.clearCache();

        return _this;
      }

      _createClass(Connect, [{
        key: "computeStateProps",
        value: function computeStateProps(store, props) {
          if (!this.finalMapStateToProps) {
            return this.configureFinalMapState(store, props);
          }

          var state = store.getState();
          var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

          if (process.env.NODE_ENV !== 'production') {
            checkStateShape(stateProps, 'mapStateToProps');
          }

          return stateProps;
        }
      }, {
        key: "configureFinalMapState",
        value: function configureFinalMapState(store, props) {
          var mappedState = mapState(store.getState(), props);
          var isFactory = typeof mappedState === 'function';
          this.finalMapStateToProps = isFactory ? mappedState : mapState;
          this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

          if (isFactory) {
            return this.computeStateProps(store, props);
          }

          if (process.env.NODE_ENV !== 'production') {
            checkStateShape(mappedState, 'mapStateToProps');
          }

          return mappedState;
        }
      }, {
        key: "computeDispatchProps",
        value: function computeDispatchProps(store, props) {
          if (!this.finalMapDispatchToProps) {
            return this.configureFinalMapDispatch(store, props);
          }

          var dispatch = store.dispatch;
          var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

          if (process.env.NODE_ENV !== 'production') {
            checkStateShape(dispatchProps, 'mapDispatchToProps');
          }

          return dispatchProps;
        }
      }, {
        key: "configureFinalMapDispatch",
        value: function configureFinalMapDispatch(store, props) {
          var mappedDispatch = mapDispatch(store.dispatch, props);
          var isFactory = typeof mappedDispatch === 'function';
          this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
          this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

          if (isFactory) {
            return this.computeDispatchProps(store, props);
          }

          if (process.env.NODE_ENV !== 'production') {
            checkStateShape(mappedDispatch, 'mapDispatchToProps');
          }

          return mappedDispatch;
        }
      }, {
        key: "updateStatePropsIfNeeded",
        value: function updateStatePropsIfNeeded() {
          var nextStateProps = this.computeStateProps(this.store, this.props);

          if (this.stateProps && shallowEqual(nextStateProps, this.stateProps)) {
            return false;
          }

          this.stateProps = nextStateProps;
          return true;
        }
      }, {
        key: "updateDispatchPropsIfNeeded",
        value: function updateDispatchPropsIfNeeded() {
          var nextDispatchProps = this.computeDispatchProps(this.store, this.props);

          if (this.dispatchProps && shallowEqual(nextDispatchProps, this.dispatchProps)) {
            return false;
          }

          this.dispatchProps = nextDispatchProps;
          return true;
        }
      }, {
        key: "updateMergedPropsIfNeeded",
        value: function updateMergedPropsIfNeeded() {
          var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);

          if (this.mergedProps && checkMergedEquals && shallowEqual(nextMergedProps, this.mergedProps)) {
            return false;
          }

          this.mergedProps = nextMergedProps;
          return true;
        }
      }, {
        key: "isSubscribed",
        value: function isSubscribed() {
          return typeof this.unsubscribe === 'function';
        }
      }, {
        key: "trySubscribe",
        value: function trySubscribe() {
          if (shouldSubscribe && !this.unsubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
            this.handleChange();
          }
        }
      }, {
        key: "tryUnsubscribe",
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (!pure || !shallowEqual(nextProps, this.props)) {
            this.haveOwnPropsChanged = true;
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
          this.clearCache();
        }
      }, {
        key: "clearCache",
        value: function clearCache() {
          this.dispatchProps = null;
          this.stateProps = null;
          this.mergedProps = null;
          this.haveOwnPropsChanged = true;
          this.hasStoreStateChanged = true;
          this.haveStatePropsBeenPrecalculated = false;
          this.statePropsPrecalculationError = null;
          this.renderedElement = null;
          this.finalMapDispatchToProps = null;
          this.finalMapStateToProps = null;
        }
      }, {
        key: "handleChange",
        value: function handleChange() {
          if (!this.unsubscribe) {
            return;
          }

          var storeState = this.store.getState();
          var prevStoreState = this.state.storeState;

          if (pure && prevStoreState === storeState) {
            return;
          }

          if (pure && !this.doStatePropsDependOnOwnProps) {
            var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);

            if (!haveStatePropsChanged) {
              return;
            }

            if (haveStatePropsChanged === errorObject) {
              this.statePropsPrecalculationError = errorObject.value;
            }

            this.haveStatePropsBeenPrecalculated = true;
          }

          this.hasStoreStateChanged = true;
          this.setState({
            storeState: storeState
          });
        }
      }, {
        key: "getWrappedInstance",
        value: function getWrappedInstance() {
          invariant(withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } as the fourth argument of the connect() call.");
          return this.refs.wrappedInstance;
        }
      }, {
        key: "render",
        value: function render() {
          var haveOwnPropsChanged = this.haveOwnPropsChanged,
              hasStoreStateChanged = this.hasStoreStateChanged,
              haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
              statePropsPrecalculationError = this.statePropsPrecalculationError,
              renderedElement = this.renderedElement;
          this.haveOwnPropsChanged = false;
          this.hasStoreStateChanged = false;
          this.haveStatePropsBeenPrecalculated = false;
          this.statePropsPrecalculationError = null;

          if (statePropsPrecalculationError) {
            throw statePropsPrecalculationError;
          }

          var shouldUpdateStateProps = true;
          var shouldUpdateDispatchProps = true;

          if (pure && renderedElement) {
            shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
            shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
          }

          var haveStatePropsChanged = false;
          var haveDispatchPropsChanged = false;

          if (haveStatePropsBeenPrecalculated) {
            haveStatePropsChanged = true;
          } else if (shouldUpdateStateProps) {
            haveStatePropsChanged = this.updateStatePropsIfNeeded();
          }

          if (shouldUpdateDispatchProps) {
            haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
          }

          var haveMergedPropsChanged = true;

          if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
            haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
          } else {
            haveMergedPropsChanged = false;
          }

          if (!haveMergedPropsChanged && renderedElement) {
            return renderedElement;
          }

          if (withRef) {
            this.renderedElement = createElement(WrappedComponent, _objectSpread({}, this.mergedProps, {
              ref: 'wrappedInstance'
            }));
          } else {
            this.renderedElement = createElement(WrappedComponent, this.mergedProps);
          }

          return this.renderedElement;
        }
      }]);

      return Connect;
    }(Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: storeShape
    };
    Connect.propTypes = {
      store: storeShape
    };

    if (process.env.NODE_ENV !== 'production') {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        } // We are hot reloading!


        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return hoistStatics(Connect, WrappedComponent);
  };
}